'use client'
import { listUsers } from "@/app/api";
import { Table, TableRow, TableHeader, TableCell, SmartLink, ColorButton, Pagination } from "@/components/ui";
import { UserSearchParams, UsersResponse } from "@/types";
import React, { useEffect, useState } from "react";

export function SellerTable() {
    const [sellerData, setSellerData] = useState<UsersResponse>()
    const [filters, setFilters] = useState<UserSearchParams>({
        page: 1,
        perPage: 10,
        order: "desc",
        orderBy: "createdAt",
        userType: "seller"
    });

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const data = await listUsers(filters)
                setSellerData(data)
            } catch (err) {
                console.log("Erro ao carregar usuários: ", err);
            }
        }

        fetchUsers()
    }, [filters]);

    const sellers = sellerData?.data || []

    const handlePageChange = (page: number) => {
        setFilters({ ...filters, page });
    };

    return (
        <div className="p-8">
            <div className="hidden md:flex">
                <Table>
                    <thead>
                        <TableRow>
                            <TableHeader>Código</TableHeader>
                            <TableHeader>Empresa</TableHeader>
                            <TableHeader>Nome</TableHeader>
                            <TableHeader>Email</TableHeader>
                            <TableHeader>Data do cadastro</TableHeader>
                            <TableHeader>Selecionar Vendedor</TableHeader>
                        </TableRow>
                    </thead>
                    <tbody>
                        {sellers.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={6} className="text-center">
                                    Não existem vendedores.
                                </TableCell>
                            </TableRow>
                        ) : (sellers.map((seller) => (
                            <React.Fragment key={seller.id}>
                                <TableRow>
                                    <TableCell>{seller.code}</TableCell>
                                    <TableCell>{seller.userName}</TableCell>
                                    <TableCell>{seller.name}</TableCell>
                                    <TableCell>{seller.email}</TableCell>
                                    <TableCell>{new Date(seller.createdAt).toLocaleDateString()}</TableCell>
                                    <TableCell>
                                        <SmartLink type={"internal"} route={"adminSellerIdClients"}
                                            params={[seller.id]}>
                                            <ColorButton>
                                                Ver Clientes
                                            </ColorButton>
                                        </SmartLink>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableHeader colSpan={2}>Observação</TableHeader>
                                    <TableCell colSpan={3}>{seller.observation}</TableCell>
                                </TableRow>
                            </React.Fragment>
                        ))
                        )
                        }
                    </tbody>

                </Table>
            </div>

            <div className="flex md:hidden">
                <Table>
                    <tbody>
                        {sellers.length === 0 ? (
                            <TableRow>
                                <TableCell className="text-center">
                                    Não existem contadores.
                                </TableCell>
                            </TableRow>
                        ) : (sellers.map((seller) => (
                            <TableRow key={seller.id}>
                                <TableHeader>Código</TableHeader>
                                <TableCell>{seller.code}</TableCell>
                                <TableHeader>Empresa</TableHeader>
                                <TableCell>{seller.userName}</TableCell>
                                <TableHeader>Nome</TableHeader>
                                <TableCell>{seller.name}</TableCell>
                                <TableHeader>Email</TableHeader>
                                <TableCell>{seller.email}</TableCell>
                                <TableHeader>Data do cadastro</TableHeader>
                                <TableCell>{new Date(seller.createdAt).toLocaleDateString()}</TableCell>
                                <TableHeader>Observação</TableHeader>
                                <TableCell>{seller.observation}</TableCell>
                                <TableHeader>Selecionar Contador</TableHeader>
                                <TableCell>
                                    <SmartLink type={"internal"} route={"adminSellerIdClients"}
                                        params={[seller.id]}>
                                        <ColorButton>
                                            Ver Clientes
                                        </ColorButton>
                                    </SmartLink>
                                </TableCell>
                                <TableCell className="border-t-2 min-w-40 border-ochre_accent" />
                            </TableRow>
                        ))
                        )
                        }
                    </tbody>
                </Table>
            </div>

            <div>
                {sellerData?.pagination &&
                    <Pagination
                        currentPage={sellerData.pagination.page}
                        totalPages={Math.ceil(sellerData.pagination.total / sellerData.pagination.perPage)}
                        onPageChange={handlePageChange}
                    />
                }
            </div>
        </div>
    )
}